import { render, staticRenderFns } from "./SubtitleComponent.vue?vue&type=template&id=ee481690&lang=pug"
import script from "./SubtitleComponent.vue?vue&type=script&lang=js"
export * from "./SubtitleComponent.vue?vue&type=script&lang=js"
import style0 from "./SubtitleComponent.vue?vue&type=style&index=0&id=ee481690&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports